import { GrpcMeta } from './grpc-transport-context';

export const FETCH_HEADERS = new GrpcMeta<Headers>();
